import { render, staticRenderFns } from "./RelBusiness.vue?vue&type=template&id=561d2474&scoped=true"
import script from "./RelBusiness.vue?vue&type=script&lang=js"
export * from "./RelBusiness.vue?vue&type=script&lang=js"
import style0 from "./RelBusiness.vue?vue&type=style&index=0&id=561d2474&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561d2474",
  null
  
)

export default component.exports